// extracted by mini-css-extract-plugin
module.exports = {"colors":"'./colors.css'","lifeomicCanvas":"#F5F8FA","lifeomicBlue":"#02bff1"};